export const STEPS = {
  LANDING: 'LANDING',
  USER_FORM: 'USER_FORM',
  VEHICLE_FORM: 'VEHICLE_FORM',
  VEHICLE_SELECT: 'VEHICLE_SELECT'
}

export const VEHICLE_FORM_ORIGINS = {
  EDIT_DATA: 'matricula corregir dato',
  NO_VEHICLE_IN_RESULTS: 'matricula mi coche no sale en la lista',
  PLATE_ERROR: 'matricula error',
  WRONG_RESULT: 'matricula no es mi coche'
}
